import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { FileRepository, ImageResize } from 'ckeditor5';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, switchMap } from 'rxjs';
import { EmailHubService } from 'src/app/private/services/email-hub.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';



@Component({
  selector: 'app-mail-right-section',
  templateUrl: './mail-right-section.component.html',
  styleUrls: ['./mail-right-section.component.scss']
})
export class MailRightSectionComponent implements AfterViewInit {
  @Input() selectedRow!: any;
  @Input() fetchingDraftData = false;
  @Input() sanitizedContent: SafeHtml | null = null;
  @Input() isComposeOpen = false;
  @Output() refresh = new EventEmitter<any>();
  @Input() loadingEmailData = false;
  @Input() activeAction: string = 'inbox';
  @Input() isDraft = false;
  @Input() currentCreatedDraftId: any;
  @Input() mailProvider: 'outlook' | 'gmail' = 'outlook';

  @Output() closeCompose = new EventEmitter<any>();
  @Output() closeCompose2 = new EventEmitter<any>();
  @Output() makeIsDraftFalse = new EventEmitter<any>();

  @ViewChild('messageContainer', { static: false }) messageContainer!: ElementRef;
  @ViewChild('mailEditorElement') mailEditorElement!: ElementRef;

  openBCC = false;
  openCC = false;
  editorData: string = ''; // Rich editor HTML content

  // Formatting state
  mailBoldActive = false;
  mailItalicActive = false;
  mailUnderlineActive = false;
  mailStrikeActive = false;
  mailBulletActive = false;
  mailOrderedActive = false;
  files: any[] = [];
  to: string = '';
  cc: string = '';
  bcc: string = '';
  subject: string = '';
  btnLoading = false;
  emailInput: string = '';
  emails: string[] = [];
  ccInput: string = '';  // Holds the current input value for CC
  ccEmails: string[] = []; // Array to store CC emails as chips
  draft_message_id: any;
  isReply = false;
  isReplyAll = false;
  isForward = false;
  hoverIndex: any = -1;
  hoverIndex2: any = -1;
  replyId: any;
  attachments: any[] = [];
  selectedAttachment: any;
  ckconfig: any;
  currentSingature: string = '';
  uploadedAttachments: any[] = []; // Array to store uploaded attachments






  constructor(
    private toast: ToastrService,
    private api: EmailHubService,
    private localStorage: LocalStorageService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private uploadService: UploadService
  ) {

  }



  ngAfterViewInit() {
    if (this.mailEditorElement && this.editorData) {
      this.mailEditorElement.nativeElement.innerHTML = this.editorData;
    }
  }

  // ─── Rich Editor Methods ────────────────────────────────────────────────────

  updateMailFormattingState() {
    try { this.mailBoldActive = document.queryCommandState('bold'); } catch {}
    try { this.mailItalicActive = document.queryCommandState('italic'); } catch {}
    try { this.mailUnderlineActive = document.queryCommandState('underline'); } catch {}
    try { this.mailStrikeActive = document.queryCommandState('strikeThrough'); } catch {}
    try { this.mailBulletActive = document.queryCommandState('insertUnorderedList'); } catch {}
    try { this.mailOrderedActive = document.queryCommandState('insertOrderedList'); } catch {}
  }

  applyMailFormat(cmd: string) {
    if (!this.mailEditorElement) { return; }
    document.execCommand(cmd, false);
    this.mailEditorElement.nativeElement.focus();
    this.updateMailFormattingState();
    this.syncMailEditorContent();
  }

  applyMailFontSize(event: any) {
    const val = event.target.value;
    if (val) {
      document.execCommand('fontSize', false, val);
      this.mailEditorElement?.nativeElement.focus();
      this.syncMailEditorContent();
    }
    event.target.value = '';
  }

  applyMailHeading(event: any) {
    const val = event.target.value;
    if (val) {
      document.execCommand('formatBlock', false, val);
      this.mailEditorElement?.nativeElement.focus();
      this.syncMailEditorContent();
    }
    event.target.value = '';
  }

  applyMailColor(event: any, cmd: string) {
    document.execCommand(cmd, false, event.target.value);
    this.mailEditorElement?.nativeElement.focus();
    this.syncMailEditorContent();
  }

  applyMailLink() {
    const url = prompt('Enter URL (include https://):', 'https://');
    if (url && url !== 'https://') {
      document.execCommand('createLink', false, url);
    }
    this.mailEditorElement?.nativeElement.focus();
    this.syncMailEditorContent();
  }

  clearMailFormatting() {
    document.execCommand('removeFormat', false);
    document.execCommand('formatBlock', false, 'div');
    this.mailBoldActive = this.mailItalicActive = this.mailUnderlineActive =
      this.mailStrikeActive = this.mailBulletActive = this.mailOrderedActive = false;
    this.mailEditorElement?.nativeElement.focus();
    this.syncMailEditorContent();
  }

  onMailEditorInput() {
    this.syncMailEditorContent();
    this.updateMailFormattingState();
  }

  onMailEditorBlur() {
    this.syncMailEditorContent();
  }

  syncMailEditorContent() {
    if (!this.mailEditorElement) { return; }
    this.editorData = this.mailEditorElement.nativeElement.innerHTML;
  }

  onMailDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onMailDrop(event: DragEvent) {
    event.preventDefault();
    const text = event.dataTransfer?.getData('text');
    if (text) {
      document.execCommand('insertText', false, text);
      this.syncMailEditorContent();
    }
  }

  TheUploadAdapterPlugin(editor: any): void {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      return new class {
        constructor(private loader: any) { }

        // Upload logic
        upload(): Promise<any> {
          return this.loader.file
            .then((file: File) =>
              new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('upload', file);

                const xhr = new XMLHttpRequest();
                xhr.open('POST', 'https://your-server.com/upload', true); // Replace with your server's endpoint
                xhr.responseType = 'json';

                xhr.onload = () => {
                  if (xhr.status === 200) {
                    // Resolve with the uploaded image URL
                    resolve({
                      default: xhr.response.url, // Ensure the server responds with the image URL
                    });
                  } else {
                    reject(`Upload failed with status ${xhr.status}`);
                  }
                };

                xhr.onerror = () => {
                  reject('An error occurred during the upload process.');
                };

                xhr.send(formData);
              })
            );
        }

        // Abort logic
        abort(): void {
          // Add abort functionality if necessary
        }
      }(loader);
    };

  }

  ngOnInit() {
    let signature = this.localStorage.getSignatures();
    signature.forEach((element: any) => {
      if (element.isActive === true || element.isActive === 'true') {
        this.currentSingature = element.signature;
      }
    });

    console.log('Current Signature:', this.currentSingature);
  }

  /** Programmatically set editor HTML (e.g. when loading a draft, reply, forward) */
  private setEditorHtml(html: string) {
    this.editorData = html;
    if (this.mailEditorElement) {
      this.mailEditorElement.nativeElement.innerHTML = html;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedRow'] && !changes['selectedRow'].firstChange) {
      // Reset flags to false if selectedRow changes

      if (this.isReply || this.isReplyAll || this.isForward) {
        this.handleUpdateDraft();
      }

      this.isReply = false;
      this.isReplyAll = false;
      this.isForward = false;
      this.replyId = null;
      this.clearData();
    }

    console.log("this draft", this.isDraft);

    if (changes['isComposeOpen'] && !changes['isComposeOpen'].firstChange) {
      if (this.isComposeOpen && this.fetchingDraftData === false &&
        this.currentSingature
      ) {
        this.setEditorHtml(`<br><br><br><br>${this.currentSingature}`);
      }
    }
  }


  selectAction(action: string): void {
    // this.bottomSheetRef.dismiss(action);
  }

  openLink(event: MouseEvent): void {
    // this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  handleOpenBCC() {
    this.openBCC = !this.openBCC;
  }

  handleOpenCC() {
    this.openCC = !this.openCC;
  }

  async onFileSelected(event: any) {
    const selectedFiles: FileList = event.target.files;

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];

      if (file.size > 4 * 1024 * 1024) {
        this.toast.error('File size cannot be more than 4MB');
        continue;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const preview = e.target.result;

        const fileObj = {
          file,
          preview,
          uploaded_url: '',
          uploading: true,
          success: false,
          error: false,
        };

        this.files.push(fileObj);
        this.uploadFileParallel(file, this.files.length - 1);
      };

      reader.readAsDataURL(file);
    }
  }

  async uploadFileParallel(file: File, index: number) {
    try {
      const presignedUrl = await this.uploadToS3(file);

      this.files[index].uploading = false;
      this.files[index].success = true;
      this.files[index].uploaded_url = presignedUrl;

      this.uploadedAttachments.push({
        fileName: file.name,
        mimeType: file.type,
        presignedUrl,
      });
    } catch (error) {
      this.files[index].uploading = false;
      this.files[index].error = true;
      this.toast.error('Upload failed for ' + file.name);
    }
  }

  async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `crm/leads/attachments`;

      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDcouments(formData).subscribe({
        next: (response: any) => {
          resolve(response.url); // assuming response returns the uploaded file URL
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }

  formatSize(size: number): string {
    if (size < 1024) return `${size} B`;
    else if (size < 1048576) return `${(size / 1024).toFixed(2)} KB`;
    else return `${(size / 1048576).toFixed(2)} MB`;
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    this.uploadedAttachments.splice(index, 1); // Remove from uploadedAttachments as well
  }

  /**
   * Gmail part-d `resolveAttachments`: use S3 presigned URL only if host looks like AWS S3
   * (backend SSRF guard); otherwise send inline base64 from the FileReader preview.
   */
  private buildGmailAttachmentsForSend(): Array<{
    name: string;
    contentType: string;
    data?: string;
    presigned_url?: string;
  }> {
    const out: Array<{ name: string; contentType: string; data?: string; presigned_url?: string }> = [];
    for (let i = 0; i < this.files.length; i++) {
      const f = this.files[i];
      const up = this.uploadedAttachments[i];
      const name = f?.file?.name || up?.fileName || 'attachment';
      const contentType = f?.file?.type || up?.mimeType || 'application/octet-stream';
      const urlStr = up?.presignedUrl != null ? String(up.presignedUrl).trim() : '';
      const looksLikeS3 =
        urlStr &&
        (/amazonaws\.com/i.test(urlStr) ||
          /\.s3[.-][^.]+\.amazonaws\.com/i.test(urlStr) ||
          /^https:\/\/s3\./i.test(urlStr));
      if (urlStr && looksLikeS3) {
        out.push({ name, contentType, presigned_url: urlStr });
      } else if (f?.preview) {
        const raw = String(f.preview);
        const data = raw.includes(',') ? raw.split(',')[1] : '';
        if (data) {
          out.push({ name, contentType, data });
        }
      }
    }
    return out;
  }

  handleUpdateDraft() {
    console.log('Draft updated.');

    const gmailDraftId =
      this.replyId || this.draft_message_id || this.currentCreatedDraftId;
    if (this.mailProvider === 'gmail' && gmailDraftId) {
      const toStr = (this.emails?.length ? this.emails.join(',') : this.emailInput) || '';
      const ccStr = (this.ccEmails?.length ? this.ccEmails.join(',') : this.ccInput) || '';
      const gmailAtt = this.buildGmailAttachmentsForSend();
      this.api
        .updateGmailDraftEmail({
          hospital_id: this.localStorage.getHospitalId(),
          user_email: this.localStorage.getMailHubUserEmail(),
          draft_id: gmailDraftId,
          to: toStr,
          cc: ccStr,
          subject: this.selectedRow?.subject || this.subject,
          body: this.editorData || '<p><br></p>',
          ...(gmailAtt.length ? { attachments: gmailAtt } : {})
        })
        .subscribe({
          next: () => {},
          error: (err: any) => {
            console.error('Error updating Gmail reply draft:', err);
          }
        });
      return;
    }

    const param = {
      subject: this.selectedRow.subject,
      contentType: 'HTML',
      bodyContent: this.editorData,
      recipientEmails: this.selectedRow.toRecipients.map((email: any) => email.emailAddress.address),
      fromEmail: this.localStorage.getMailHubUserEmail(),
      ccRecipients: this.selectedRow.ccRecipients.map((email: any) => email.emailAddress.address),
      // attachments: this.files,
      hospital_id: this.localStorage.getHospitalId(),
      messageId: this.replyId,
      draft_message_id: this.replyId
    }

    this.clearData();

    console.log('Draft email param:', param);
    this.api.updateOutlookDraftEmail(param).subscribe({
      next: (res: any) => {
        console.log('Draft updated successfully:', res);

      },
      error: (err: any) => {
        console.error('Error updating draft:', err);
      }
    });
  }


  closeBottomSheet() {
    if (this.isReply || this.isReplyAll || this.isForward) {
      if (this.files.length > 0) {

        this.finalizeClose2();

      } else {
        // Directly update draft if there are no files
        this.handleUpdateDraft();
        this.finalizeClose();
      }
    } else {
      // Finalize close if none of the conditions are met
      this.finalizeClose();
    }
  }

  finalizeClose() {
    this.isReply = false;
    this.isReplyAll = false;
    this.isForward = false;
    this.closeCompose.emit();
  }

  finalizeClose2() {
    this.isReply = false;
    this.isReplyAll = false;
    this.isForward = false;
    this.closeCompose2.emit();
  }

  handleEmailAction(actionType: any) {
    if (this.mailProvider === 'gmail') {
      this.sendEmail(actionType);
      return;
    }

    if (this.files.length > 0) {
      const attachments = this.files.map((file) => ({
        "@odata.type": "#microsoft.graph.fileAttachment",
        "name": file.file.name,
        "contentType": file.file.type,
        "contentBytes": file.preview?.split(',')[1]
      }));

      const attachmentPayload = {
        fromEmail: this.localStorage.getMailHubUserEmail(),
        draft_id: this.replyId,
        hospital_id: this.localStorage.getHospitalId(),
        attachments: attachments
      };

      this.api.addAttachmentInOutlookReply(attachmentPayload).subscribe({
        next: () => this.sendEmail(actionType),
        error: (e) => this.handleError(e, 'Error adding attachments')
      });
    } else {
      this.sendEmail(actionType);
    }
  }

  /**
   * Gmail `drafts.create` returns `{ id: "<draftId>", message: { id: "<messageId>", ... } }`.
   * Updates/sends must use **draft** `id` only — `message.id` is wrong and yields 400 from the API.
   */
  private extractGmailDraftId(res: any): string | undefined {
    if (!res) return undefined;
    return res.id ?? res.draft_id ?? res.data?.id ?? undefined;
  }

  private sendEmailGmail(actionType: any) {
    const hospital_id = this.localStorage.getHospitalId();
    const user_email = this.localStorage.getMailHubUserEmail();
    const ccStr = (this.ccEmails?.length ? this.ccEmails.join(',') : this.ccInput) || '';

    if (actionType === 'forward') {
      const toStr = (this.emails?.length ? this.emails.join(',') : this.emailInput) || '';
      const gmailAtt = this.buildGmailAttachmentsForSend();
      this.api
        .forwardGmailEmail({
          hospital_id,
          user_email,
          to: toStr,
          cc: ccStr,
          subject: this.subject,
          body: this.editorData || '<p><br></p>',
          ...(gmailAtt.length ? { attachments: gmailAtt } : {})
        })
        .pipe(
          switchMap((res: any) => {
            const draftId = this.extractGmailDraftId(res);
            if (!draftId) {
              throw new Error('No draft id from Gmail forward');
            }
            return this.api.sendGmailDraftEmail({ hospital_id, user_email, draft_id: draftId });
          }),
          catchError((err: any) => {
            console.error(err);
            this.toast.error('Error sending email');
            this.btnLoading = false;
            return of(null);
          })
        )
        .subscribe((res: any) => {
          if (res) {
            this.handleSuccess('Email sent successfully');
          }
        });
      return;
    }

    /**
     * Reply-All must match `createGmailReplyAllDraft`: To = from + original To only; Cc = original Cc.
     * Putting everyone in To *and* listing Cc duplicates addresses and Gmail often returns 400.
     */
    let toStr = '';
    if (actionType === 'replyAll') {
      const toList = [
        this.selectedRow.from.emailAddress.address,
        ...this.selectedRow.toRecipients.map((email: any) => email.emailAddress.address)
      ];
      toStr = [...new Set(toList.filter(Boolean))].join(',');
    } else {
      toStr = this.selectedRow.from.emailAddress.address || '';
    }
    const replyCcStr = (this.ccEmails?.length ? this.ccEmails.join(',') : this.ccInput) || '';
    const gmailAtt = this.buildGmailAttachmentsForSend();

    const sendReply = () => {
      if (!this.replyId) {
        this.toast.error('Reply draft is not ready yet. Please wait a moment and try again.');
        this.btnLoading = false;
        return;
      }
      this.api
        .updateGmailDraftEmail({
          hospital_id,
          user_email,
          draft_id: this.replyId,
          to: toStr,
          cc: replyCcStr,
          subject: this.subject,
          body: this.editorData || '<p><br></p>',
          ...(gmailAtt.length ? { attachments: gmailAtt } : {})
        })
        .pipe(
          switchMap(() =>
            this.api.sendGmailReplyEmail({
              hospital_id,
              user_email,
              draft_id: this.replyId
            })
          ),
          catchError((err: any) => {
            console.error(err);
            this.toast.error('Error sending email');
            this.btnLoading = false;
            return of(null);
          })
        )
        .subscribe((res: any) => {
          if (res) {
            this.handleSuccess('Reply sent successfully');
          }
        });
    };

    if (!this.replyId) {
      let tries = 0;
      const maxTries = 100;
      const t = setInterval(() => {
        tries++;
        if (this.replyId) {
          clearInterval(t);
          sendReply();
        } else if (tries >= maxTries) {
          clearInterval(t);
          this.toast.error('Reply draft timed out. Please close the composer and try Reply again.');
          this.btnLoading = false;
        }
      }, 50);
      return;
    }

    sendReply();
  }

  sendEmail(actionType: any) {
    if (this.mailProvider === 'gmail') {
      this.sendEmailGmail(actionType);
      return;
    }

    let recipientEmails: any[] = [];
    if (actionType === 'forward') {
      recipientEmails = this.emails?.length > 0 ? this.emails : [this.emailInput];
    } else if (actionType === 'replyAll') {
      recipientEmails = [this.selectedRow.from.emailAddress.address, ...this.selectedRow.toRecipients.map((email: any) => email.emailAddress.address),
      ...this.selectedRow.ccRecipients.map((email: any) => email.emailAddress.address)
      ];
    } else if (actionType === 'reply') {
      recipientEmails = [this.selectedRow.from.emailAddress.address];
    }

    const emailPayload = {
      fromEmail: this.localStorage.getMailHubUserEmail(),
      draft_message_id: this.replyId,
      contentType: 'HTML',
      hospital_id: this.localStorage.getHospitalId(),
      bodyContent: this.editorData,
      recipientEmails: recipientEmails
    };

    this.api.sendOutlookReply(emailPayload).subscribe({
      next: () => this.handleSuccess('Reply sent successfully'),
      error: (e) => this.handleError(e, 'Error sending email')
    });
  }

  handleSuccess(message: any) {
    this.toast.success(message);
    setTimeout(() => {
      this.btnLoading = false;
      this.refresh.emit();
      this.closeCompose.emit();
      this.resetForm();
    }, 1000);
  }

  handleError(error: any, message: any) {
    console.error(error);
    this.toast.error(message);
    this.btnLoading = false;
  }

  resetForm() {
    this.openBCC = false;
    this.openCC = false;
    this.subject = '';
    this.setEditorHtml('');
    this.files = [];
    this.emails = [];
    this.ccEmails = [];
    this.emailInput = '';
    this.ccInput = '';
    this.isReply = false;
    this.isReplyAll = false;
    this.isForward = false;
    this.replyId = null;
    this.closeBottomSheet();
    this.clearData();
  }

  handleReplyMessage() {
    this.handleEmailAction('reply');
  }

  handleReplyAllMessage() {
    this.handleEmailAction('replyAll');
  }

  handleForwardMessage() {
    this.handleEmailAction('forward');
  }


  sendMail() {
    // if (!this.to) {
    //   this.toast.error('Please enter a recipient email address');
    //   return;
    // }'

    if (this.isForward) {

      if (this.emails.length === 0 && !this.emailInput) {
        this.toast.error('Please enter a recipient email address');
        return;
      }

      this.btnLoading = true;

      this.handleForwardMessage();

      return;
    }

    if (this.isReplyAll) {
      if (!this.editorData) {
        this.toast.error('Please enter a message');
        return;
      }

      this.btnLoading = true;

      this.handleReplyAllMessage();

      return;
    }

    if (this.isReply) {
      if (!this.editorData) {
        this.toast.error('Please enter a message');
        return;
      }

      this.btnLoading = true;

      this.handleReplyMessage();

      return;
    }

    if (this.emails.length === 0 && !this.emailInput) {
      this.toast.error('Please enter a recipient email address');
      return;
    }

    if (!this.subject) {
      this.toast.error('Please enter a subject');
      return;
    }

    if (!this.editorData) {
      this.toast.error('Please enter a message');
      return;
    }

    console.log('Sending email...');
    this.btnLoading = true;

    if (this.mailProvider === 'gmail') {
      const draftId =
        this.currentCreatedDraftId || this.selectedRow?.gmailDraftId || this.selectedRow?.id;
      const toStr = (this.emails?.length ? this.emails.join(',') : this.emailInput) || '';
      const ccStr = (this.ccEmails?.length ? this.ccEmails.join(',') : this.ccInput) || '';

      if (!draftId) {
        this.toast.error('Could not find a draft to send');
        this.btnLoading = false;
        return;
      }

      const gmailAtt = this.buildGmailAttachmentsForSend();

      this.api
        .updateGmailDraftEmail({
          hospital_id: this.localStorage.getHospitalId(),
          user_email: this.localStorage.getMailHubUserEmail(),
          draft_id: draftId,
          to: toStr,
          cc: ccStr,
          subject: this.subject,
          body: this.editorData || '<p><br></p>',
          ...(gmailAtt.length ? { attachments: gmailAtt } : {})
        })
        .pipe(
          switchMap(() =>
            this.api.sendGmailDraftEmail({
              hospital_id: this.localStorage.getHospitalId(),
              user_email: this.localStorage.getMailHubUserEmail(),
              draft_id: draftId
            })
          ),
          catchError((err: any) => {
            console.error('Error occurred:', err);
            this.toast.error('An error occurred while processing your request');
            this.btnLoading = false;
            return of(null);
          })
        )
        .subscribe((res: any) => {
          if (res) {
            this.handleSuccess('Email sent successfully');
          }
        });
      return;
    }

    // let attachments: any[] = [];

    // this.files.forEach((file) => {
    //   attachments.push({
    //     "@odata.type": "#microsoft.graph.fileAttachment",
    //     "name": file.file.name,
    //     "contentType": file.file.type,
    //     "contentBytes": file.preview?.split(',')[1]
    //   });
    // });

    const param: any = {
      subject: this.subject,
      contentType: 'HTML',
      bodyContent: this.editorData,
      recipientEmails: this.emails?.length > 0 ? this.emails : [this.emailInput],
      fromEmail: this.localStorage.getMailHubUserEmail(),
      ccRecipients: this.ccEmails?.length > 0 ? this.ccEmails : this.ccInput ? [this.ccInput] : [],
      hospital_id: this.localStorage.getHospitalId(),
      draft_message_id: this.currentCreatedDraftId ? this.currentCreatedDraftId : this.selectedRow?.id
    }

    const attachmentPayload = {
      fromEmail: this.localStorage.getMailHubUserEmail(),
      draft_id: this.currentCreatedDraftId ? this.currentCreatedDraftId : this.selectedRow?.id,
      hospital_id: this.localStorage.getHospitalId(),
      attachments: this.uploadedAttachments
    };

    const uploadAttachments$ = this.uploadedAttachments.length > 0
      ? this.api.addAttachmentInOutlookReply(attachmentPayload)
      : of(null); // Return an observable that emits null if no attachments

    uploadAttachments$
      .pipe(
        switchMap(() =>
          this.api.updateOutlookDraftEmail(param) // Update draft email after attachments upload
        ),
        switchMap(() =>
          this.api.sendOutlookDraftEmail(param) // Send email after update
        ),
        catchError((err: any) => {
          console.error('Error occurred:', err);
          this.toast.error('An error occurred while processing your request');
          this.btnLoading = false;
          // Return an empty observable or handle fallback here
          return of(null);
        })
      )
      .subscribe((res: any) => {
        if (res) {
          this.toast.success('Email sent successfully');
          setTimeout(() => {
            this.btnLoading = false;
            this.refresh.emit();
            this.makeIsDraftFalse.emit();
            this.closeCompose.emit();
            this.openBCC = false;
            this.openCC = false;
            this.subject = '';
            this.setEditorHtml('');
            this.files = [];
            this.emails = [];
            this.ccEmails = [];
            this.emailInput = '';
            this.ccInput = '';
          }, 1000);
        }
      });




  }

  addEmail(): void {
    if (this.emailInput && this.isValidEmail(this.emailInput)) {
      this.emails.push(this.emailInput);
      this.emailInput = '';  // Clear the input field
    } else {
      // alert('Please enter a valid email address.');
      this.toast.error('Please enter a valid email address.');
    }
  }

  // Remove email from the chip list
  removeEmail(email: string): void {
    const index = this.emails.indexOf(email);
    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  addCc(): void {
    if (this.ccInput && this.isValidEmail(this.ccInput)) {
      this.ccEmails.push(this.ccInput);
      this.ccInput = '';  // Clear the input field
    } else {
      // alert('Please enter a valid CC email address.');
      this.toast.error('Please enter a valid CC email address.');
    }
  }

  // Remove CC email from the chip list
  removeCc(ccEmail: string): void {
    const index = this.ccEmails.indexOf(ccEmail);
    if (index >= 0) {
      this.ccEmails.splice(index, 1);
    }
  }


  // Validate email format using a simple regex (optional)
  isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  clearData() {
    this.subject = '';
    this.setEditorHtml('');
    this.files = [];
    this.emails = [];
    this.ccEmails = [];
    this.emailInput = '';
    this.ccInput = '';
    this.attachments = [];
  }

  fillData(data: any, content: string) {
    this.draft_message_id = data.id;
    this.subject = data.subject;
    this.setEditorHtml(content);
    this.emails = data?.toRecipients?.map((email: any) => email.emailAddress.address);
    this.openCC = data.ccRecipients?.length > 0;
    this.ccEmails = data.ccRecipients?.map((email: any) => email.emailAddress.address);
    // this.files = data.attachments;
  }

  handleReply() {
    this.isReply = true;
    this.subject = `Re: ${this.selectedRow.subject}`;
    this.emails = [this.selectedRow.from.emailAddress.address];
    this.openCC = false;
    this.ccEmails = [];

    setTimeout(() => {
      this.scrollToTop();
    }, 100);

    if (this.mailProvider === 'gmail') {
      const toAddr = this.selectedRow.from.emailAddress.address;
      this.api
        .createGmailReplyDraft({
          hospital_id: this.localStorage.getHospitalId(),
          user_email: this.localStorage.getMailHubUserEmail(),
          to: toAddr,
          cc: '',
          subject: this.subject,
          body: '<p><br></p>',
          reply_to_message_id: this.selectedRow.id,
          thread_id: this.selectedRow.threadId || this.selectedRow.id
        })
        .subscribe({
          next: (res: any) => {
            this.replyId = this.extractGmailDraftId(res);
          },
          error: (e) => console.error(e)
        });
      return;
    }

    const payload = {
      fromEmail: this.localStorage.getMailHubUserEmail(),
      message_id: this.selectedRow.id,
      hospital_id: this.localStorage.getHospitalId()
    }

    this.api.createOutlookReply(payload).subscribe({
      next: (res) => {
        this.replyId = res?.id;

        console.log('Reply ID:', this.replyId);
      },
      error: (e) => {
        console.error(e);
      }
    });

  }

  handleReplyAll() {
    this.isReply = true;
    this.isReplyAll = true;
    this.subject = `Re: ${this.selectedRow.subject}`;
    this.emails = [this.selectedRow.from.emailAddress.address, ...this.selectedRow.toRecipients.map((email: any) => email.emailAddress.address)];

    // remove duplicates
    this.emails = this.emails.filter((email, index, self) => self.indexOf(email) === index);

    this.ccEmails = this.selectedRow.ccRecipients.map((email: any) => email.emailAddress.address);
    this.openCC = this.ccEmails.length > 0;

    setTimeout(() => {
      this.scrollToTop();
    }, 100);

    if (this.mailProvider === 'gmail') {
      const toList = [
        this.selectedRow.from.emailAddress.address,
        ...this.selectedRow.toRecipients.map((email: any) => email.emailAddress.address)
      ];
      const uniqueTo = [...new Set(toList.filter(Boolean))];
      const toStr = uniqueTo.join(',');
      const ccStr = this.selectedRow.ccRecipients
        .map((email: any) => email.emailAddress.address)
        .filter(Boolean)
        .join(',');
      this.api
        .createGmailReplyAllDraft({
          hospital_id: this.localStorage.getHospitalId(),
          user_email: this.localStorage.getMailHubUserEmail(),
          to: toStr,
          cc: ccStr || '',
          subject: this.subject,
          body: '<p><br></p>',
          reply_to_message_id: this.selectedRow.id,
          thread_id: this.selectedRow.threadId || this.selectedRow.id
        })
        .subscribe({
          next: (res: any) => {
            this.replyId = this.extractGmailDraftId(res);
          },
          error: (e) => console.error(e)
        });
      return;
    }

    const payload = {
      fromEmail: this.localStorage.getMailHubUserEmail(),
      message_id: this.selectedRow.id,
      hospital_id: this.localStorage.getHospitalId()
    }

    this.api.createOutlookReply(payload).subscribe({
      next: (res) => {
        this.replyId = res?.id;

        console.log('Reply ID:', this.replyId);
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  handleForward() {
    this.isForward = true;
    this.subject = `Fwd: ${this.selectedRow.subject}`;
    this.emails = [];
    this.openCC = false;
    this.ccEmails = [];

    setTimeout(() => {
      this.scrollToTop();
    }, 100);

    if (this.mailProvider === 'gmail') {
      this.replyId = null;
      return;
    }

    const payload = {
      fromEmail: this.localStorage.getMailHubUserEmail(),
      message_id: this.selectedRow.id,
      hospital_id: this.localStorage.getHospitalId()
    }

    this.api.forwardOutlookEmail(payload).subscribe({
      next: (res) => {
        this.replyId = res?.id;
        console.log('Reply ID:', this.replyId);
      },
      error: (e) => {
        console.error(e);
      }
    });


  }

  isImage(file: File): boolean {
    return file?.type?.startsWith('image/');
  }

  isVideo(file: File): boolean {
    return file?.type?.startsWith('video/');
  }

  isPDF(file: File): boolean {
    return file?.type === 'application/pdf';
  }

  scrollToTop(): void {
    console.log("scrolling to top");
    try {
      this.messageContainer.nativeElement.scrollTo({
        top: 0, // Scroll to the top
        behavior: 'smooth' // Enables smooth scrolling
      });
    } catch (err) {
      console.error('Scroll to top failed:', err);
    }
  }

  getImageUrl(contentType: string, contentBytes: string): any {
    if (!contentBytes) return '';
    const base64Url = `data:${contentType};base64,${contentBytes}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Url);
  }


  openInNewTab(url: string): void {
    // const encodedUrl = encodeURIComponent(url); // Encode if necessary
    // console.log('Opening URL:', encodedUrl);
    // window.open(encodedUrl, '_blank');
  }

  openAttachment(
    content: any, attachment: any
  ) {

    this.selectedAttachment = {
      name: attachment.name,
      contentType: attachment.contentType,
      url: this.getImageUrl(attachment.contentType, attachment.contentBytes)
    };

    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true,
      backdrop: 'static',
    })
  }

  downloadFile(attachment: any): void {
    // If bytes are already available, download directly
    if (attachment?.contentBytes) {
      this.triggerDownload(attachment.name, attachment.contentType, attachment.contentBytes);
      return;
    }

    // No bytes yet — need to fetch them first
    const messageId = this.selectedRow?.id;
    if (!messageId) {
      this.toast.error('Cannot download: message ID is missing.');
      return;
    }

    if (this.mailProvider === 'gmail') {
      this.toast.info('Fetching attachment…');
      this.api.getGmailEmailAttachments({
        hospital_id: this.localStorage.getHospitalId(),
        user_email: this.localStorage.getMailHubUserEmail(),
        message_id: messageId,
        attachment_id: attachment.id
      }).subscribe({
        next: (res: any) => {
          const bytes = res?.data ?? res?.contentBytes ?? res;
          if (!bytes) {
            this.toast.error('Attachment data not available.');
            return;
          }
          this.triggerDownload(attachment.name, attachment.contentType, bytes);
        },
        error: (err: any) => {
          console.error('Error fetching Gmail attachment:', err);
          this.toast.error('Failed to fetch attachment from Gmail.');
        }
      });
    } else {
      // Outlook — re-fetch attachments list which includes contentBytes
      this.toast.info('Fetching attachment…');
      this.api.getOutlookEmailAttachments({
        fromEmail: this.localStorage.getMailHubUserEmail(),
        hospital_id: this.localStorage.getHospitalId(),
        message_id: messageId
      }).subscribe({
        next: (res: any) => {
          const found = (res?.value ?? []).find((a: any) =>
            a.name === attachment.name || a.id === attachment.id
          );
          if (!found?.contentBytes) {
            this.toast.error('Attachment data not available.');
            return;
          }
          this.triggerDownload(found.name, found.contentType, found.contentBytes);
        },
        error: (err: any) => {
          console.error('Error fetching Outlook attachment:', err);
          this.toast.error('Failed to fetch attachment from Outlook.');
        }
      });
    }
  }

  private triggerDownload(name: string, contentType: string, contentBytes: string): void {
    try {
      const blob = this.base64ToBlob(contentBytes, contentType);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      this.toast.error('Failed to download attachment. File data may be corrupted.');
    }
  }

  /**
   * Convert Base64 string to Blob
   */
  private base64ToBlob(base64: string, contentType: string): Blob {
    // Clean and sanitize base64 string
    let cleanBase64 = base64
      .replace(/\s+/g, '') // Remove all whitespace (spaces, tabs, newlines)
      .replace(/[^A-Za-z0-9+/=]/g, ''); // Remove invalid base64 characters
    
    // Add proper padding if needed
    const padding = cleanBase64.length % 4;
    if (padding) {
      cleanBase64 += '='.repeat(4 - padding);
    }
    
    let byteCharacters: string;
    try {
      byteCharacters = atob(cleanBase64); // Decode Base64
    } catch (e) {
      console.error('Invalid base64 data:', e);
      throw new Error('Invalid file data encoding. Cannot decode attachment.');
    }
    
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  onReady(editor: any) {
    // Set custom upload adapter (optional, as you have)
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      return new UploadAdapter(loader);
    };

    // Custom behavior: replace default Enter with Shift+Enter
    editor.editing.view.document.on(
      'enter',
      (evt: any, data: any) => {
        editor.execute('shiftEnter'); // insert <br> instead of <p>
        data.preventDefault();        // cancel default enter
        evt.stop();                   // stop further handling
      },
      { priority: 'high' }
    );
  }

  // onReady(eventData: any) {
  //   eventData.plugins.get('FileRepository').createUploadAdapter = function (loader: any) {
  //     console.log(btoa(loader.file));
  //     return new UploadAdapter(loader);
  //   };

  //   eventData.plugins.get('ImageResize').enable({
  //     handleSize: 50,
  //     handleStyles: {
  //       display: 'block',
  //       'background-color': 'black',
  //       'border-radius': '50%',
  //       'border': '1px solid white',
  //       'box-shadow': '0 0 0 2px black',
  //       'box-sizing': 'content-box',
  //       'height': '16px',
  //       'width': '16px'
  //     }
  //   });

  //   // editorObj.keystrokes.set('Shift+Enter', 'enter');
  //   // editor.value = editorObj;

  //   eventData.editing.view.document.on(
  //     'enter',
  //     (evt: any, data: any) => {
  //       eventData.execute('shiftEnter'); // insert <br> instead of <p>
  //       data.preventDefault();        // cancel default enter
  //       evt.stop();                   // stop further handling
  //     },
  //     { priority: 'high' }
  //   );

  // }



  removeAttchment(index: number,
    attachmentId: any
  ) {

    this.attachments.splice(index, 1);

    if (this.mailProvider === 'gmail') {
      return;
    }

    const payload = {
      fromEmail: this.localStorage.getMailHubUserEmail(),
      draft_message_id: this.draft_message_id,
      attachment_id: attachmentId,
      hospital_id: this.localStorage.getHospitalId()
    }

    this.api.deleteAttachmentInOutlook(payload).subscribe({
      next: (res) => {
        console.log('Attachment deleted:', res);
      },
      error: (e) => {
        console.error('Error deleting attachment:', e);
      }
    });
  }


}


export class UploadAdapter {
  private loader: any;

  constructor(loader: any) {
    this.loader = loader;
  }

  public async upload(): Promise<any> {
    return this.loader.file
      .then((file: File) => this.readThis(file))
      .then((dataUrl: any) => {
        return { default: dataUrl };
      });
  }

  readThis(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }
}